/*
  This file sets the adaptive view type of the application (desktop vs mobile)
  It will first set the view type on the server side by checking the device type
  Once it reaches the client side it will do another check for view type based on the screen size
  The screen size's view type will overwrite the device type-based view type and it will update viewtype if necessary
*/
import { onServerPrefetch } from 'vue';
import { useNavExperimentation } from '~/stores/navExperimentation';

import { SETUP_CLIENT_SIDE_EXPERIMENTATION, SETUP_SERVER_SIDE_EXPERIMENTATION } from '#shared/types/actions';

const handleServerSideExpermentation = (store) => onServerPrefetch(() => store[SETUP_SERVER_SIDE_EXPERIMENTATION]());
const handleClientSideExperimentation = (store) => {
  if (import.meta.client) {
    store[SETUP_CLIENT_SIDE_EXPERIMENTATION]();
  }
};

export function useInitExperimentation() {
  const store = useNavExperimentation();
  handleServerSideExpermentation(store);
  handleClientSideExperimentation(store);
}
